
# This is the Handler class. The Handler class is the basis for most all of the JS
# code on the site.
#
# Handlers are simply ways to group up code for a page, tab, dialog, or "tool"
#
# This base Handler class will never be used on it's own, but is extended and overridden
# by nearly all the coffeescript classes on the site
#
#
DI = require('resources/assets/coffee/Core/DependencyInjection').DependencyInjection

class exports.Handler extends DI

    # Simply initializes some class attributes, like layoutSelector
    # and layoutUrl
    #
    # * layoutUrl
    #   * The url that {#loadLayout} will post to to grab the layout
    # * layoutSelector
    #   * The DOM selector that {#loadLayout} will insert the fetched layout into
    #
    constructor: (name, data = {}) ->
        super()
        App.load('core::widget_resizr')

        @__destroyed    = false
        @__request      = null

        @nameInParent   = null

        # Selectors - sidebar_content, usually
        # TODO: we should probably just create a Sidebar_Handler class
        @layoutSelector = App.sidebar?.contentDiv()
        @sidebar_open = true
        @emptySidebarWriter = true
        @autofocus = true
        @removeMessageOnLoad = true

        # URLs
        @layoutUrl      = "#{name}/load-layout"

        @extraData      = data
        @taffyObjects   = {}

        # Do we only allow one active sub handler?
        # Or do we let people instantiate a bunch?
        @singleSubHandler = true
        @activeSubHandlers = {}

        # this will prevent message writer 'hangs' when quickly
        # switching from a tab that uses a writer to a tab that doesnt
        App.sidebar?.messageWriter().message_writer 'clear'


    isDestroyed: () ->
        return @__destroyed


    # Classes that inherit handler should use the init function
    # to do anything special. Usually, Init simply calls alters default class
    # attributes, and calls loadLayout
    #
    init: () -> #stub
        undefined

    destroy: (clear = true) ->

        # console.log 'I got destroyed', @.constructor.toString()
        @__destroyed = true
        if @__request?
            @__request.abort()
        #$(window).trigger("handler_destroyed",[this])
        for i, v of @activeSubHandlers
            v.destroy()

        selector = @_getLayoutSelector()
        if selector? and clear
            if selector.length > 0
                ko.cleanNode selector[0]
            selector.empty()

        if @emptySidebarWriter and App.sidebar.messageWriter().data('customMessage_writer')
            App.sidebar.messageWriter().message_writer 'clear'


        if @parent?
            @parent.destroySubHandler(@nameInParent)


    _getLayoutSelector: (selector) =>
        if not selector?
            selector = @layoutSelector

        if selector?
            if selector instanceof jQuery
                return selector

            return $(selector)

        return null


    refresh: (clear = true) ->
        for i, v of @activeSubHandlers
            v.destroy()

        selector = @_getLayoutSelector()
        if selector? and clear
            selector.empty()

        @init()


    ###
    If the subs are TABS and they are in App.sidebar.contentDiv(), they should automagically work
    (if they were named correctly)
    ###
    createSubHandler: (sub, name = null) ->
        # we shouldn't be having children if we're dead!
        if @__destroyed then return null

        handler = (@subHandlers?[sub]?.class) ? sub
        if not handler
            return null

        name    = name ? handler

        # Handle destroying current handler (if we have
        # singleSubHandler set to true). If we already have
        # a subhandler with the name we want exists
        if @singleSubHandler
            for i, v of @activeSubHandlers
                v.destroy()
        else if @activeSubHandlers[name]?
            # shouldn't we return the active subhandler then?
            return false

        # If the handler we detected is a string, we'll
        # assume it's a path for a module to be required.
        # If it's not, we'll assume that it's a class that
        # we can instantiate
        if typeof handler is 'string'
            object = window.App.loadClass(handler)
        else
            object = handler

        # Instantiate the handler, and assign it.
        handlerObj = new object()
        handlerObj.nameInParent = name
        handlerObj.parent = this

        @activeSubHandlers[name] = handlerObj

        # If we have any other attributes in the subHandlers definition
        # for the requested subhandler, then assign them.
        if @subHandlers?[sub]?.attrs
            for k, v of @subHandlers[sub].attrs
                @activeSubHandlers[name][k] = v

        return @activeSubHandlers[name]



    destroySubHandler: (name, calldestroy = false) ->
        if @subHandlers?[name]?
            name = @subHandlers[name].class

        if @activeSubHandlers?[name]?
            if calldestroy
                @activeSubHandlers[name].destroy()
            else
                @activeSubHandlers[name] = null
                delete @activeSubHandlers[name]


    destroyAllSubHandlers: () ->
        for k, v of @activeSubHandlers
            @destroySubHandler k, true


    refreshSubHandlers: (subs = []) ->
        if subs.length is 0
            for i, v of @activeSubHandlers
                v.refresh()
        else
            for i in subs
                @activeSubHandlers[i].refresh()


    loadLayout: (options = {}) -> (

        url = options.url ? @layoutUrl ? @layoutSource
        postOps = options.postOptions ? @loadLayoutPostOptions ? {}
        callback = options.callback ? null
        selector = options.selector ? @layoutSelector

        sel = @_getLayoutSelector(selector)

        sel.empty()

        if not url?
            callback() if callback?
        else
            if url instanceof jQuery
                sel.html url.html()
                if callback?
                    callback sel, {}
                else
                    # Auto focus first input
                    if @autofocus
                        sel.find('input,select')[0]?.focus()
                    @afterLoadLayout sel, {}
            else
                processData = true
                contentType = 'application/x-www-form-urlencoded; charset=UTF-8'

                if postOps instanceof FormData
                    processData = false
                    contentType = false

                @__request = $.ajax
                    type: 'POST'
                    url: url
                    data: postOps
                    processData: processData
                    contentType: contentType
                    success: (data) =>

                        if @__destroyed
                            return null

                        if data? and data.status?.type is 'logout'
                            window.location = '/home'
                            return

                        if sel?
                            if @removeMessageOnLoad
                                sel.removeClass 'dialog-loading'
                            if data? and data.view?
                                sel.html data.view
                            else
                                sel.html data

                        if data? and data.status?.type is 'denied'
                            App.sidebar?.open()
                            App.sidebar?.contentDiv()?.html(data.view)
                            return

                        @loadTaffy data

                        if callback?
                            callback(sel, data)
                        else
                            # Auto focus first input
                            if @autofocus
                                sel.find('input,select')[0]?.focus()
                            @afterLoadLayout(sel, data)

    )


    loadTaffy: (data) ->
        if data.taffy?
            for k, v of data.taffy
                @taffyObjects[k] = TAFFY(v)


    afterLoadLayout: (selector, data) ->
        undefined


    selectSort: (a, b) ->
        if a.text > b.text
            return 1
        else if a.text < b.text
            return -1
        return 0


    # TODO: this should be in a separate utility or jQuery plugin or something
    moveOptions: (from, to) ->
        if not (from instanceof jQuery)
            from = $(from)

        if not (to instanceof jQuery)
            to = $(to)

        vals = from.val()
        if vals
            for val in vals
                sel = 'option[value="' + val + '"]'
                from.find(sel).appendTo(to)
                from.find(sel).remove()
            to.find('option').sort(@selectSort).appendTo(to)
            to.val('')
